import { makeStyles } from '@material-ui/styles';

export default makeStyles({
    circularProgress: {
        display:'flex',
        height: '-webkit-fill-available',
        justifyContent:'center',
        alignItems: 'center'
    },
});